import { MobileOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/UI/Button";
import GgLogo from "../../../../components/icons/GgLogo";
import styles from "./MobileAppPrompt.module.scss";

type MobileAppPromptProps = {
  downloadUrl: string;
  onLater: () => void;
};

function MobileAppPrompt({ downloadUrl, onLater }: MobileAppPromptProps) {
  const { t } = useTranslation("layout", { keyPrefix: "mobileAppPrompt" });

  return (
    <div className={styles.page}>
      <div className={styles.logo}>
        <GgLogo width={140} height={36} />
      </div>
      <div className={styles.card}>
        <div className={styles.icon}>
          <MobileOutlined />
        </div>
        <p className={styles.message}>{t("message")}</p>
        <div className={styles.actions}>
          <Button
            variant="filled"
            theme="primary"
            className={styles.button}
            onClick={() => window.location.assign(downloadUrl)}
          >
            {t("download")}
          </Button>
          <Button
            variant="outlined"
            className={styles.button}
            onClick={onLater}
          >
            {t("later")}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default MobileAppPrompt;
